import React from "react";
import styled from "styled-components";
import { Colors } from "../../../config";
import { MainLabel, Sublabel } from "./EachViewDetails";

const AirportDetail = ({ place, time, date, airport }) => {
  return (
    <PlaceAndTime>
      <NameAndTime>
        {place} <span>{time}</span>
      </NameAndTime>
      <MainLabel>{date}</MainLabel>
      <Sublabel>{airport}</Sublabel>
    </PlaceAndTime>
  );
};

export default AirportDetail;

const NameAndTime = styled.div`
  font-weight: 300;
  font-size: 1.5rem;
  color: ${Colors.sharkApprox};
  > span {
    font-weight: 700;
  }
`;
const PlaceAndTime = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 1rem;
  max-width: 12.5rem;
`;
